/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Page_Main_TitleInputs */

const en_vc_page_main_title = /** @type {(inputs: Vc_Page_Main_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft: Free Open-Source Illustrator Alternative (Download & Online)`)
};

const zh_vc_page_main_title = /** @type {(inputs: Vc_Page_Main_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft：免费开源的 Illustrator 替代品（下载与在线版）`)
};

/**
* | output |
* | --- |
* | "VectorCraft: Free Open-Source Illustrator Alternative (Download & Online)" |
*
* @param {Vc_Page_Main_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_page_main_title = /** @type {((inputs?: Vc_Page_Main_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Page_Main_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_page_main_title(inputs)
	return zh_vc_page_main_title(inputs)
});
export { vc_page_main_title as "vc.page.main.title" }